import { Params } from "@angular/router";
import { IBaseClient } from "./base-client/interface";
import { CblClient } from "./customer-client/cbl-client";
import { SbhClient } from './service-bench-client/sbh-client';
import { TimxClient } from "./timx-client/timx-client";
import { UnknownClient } from "./unknown-client/unknown-client";
import { ZohoClient } from './zoho-client/zoho-client';
import { ICommonPaymentData } from "../interfaces";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ClientId {
  constructor(
    private sbhClient: SbhClient,
    private cblClient: CblClient,
    private timxClient: TimxClient,
    private zohoClient: ZohoClient,
    private unknownClient: UnknownClient
  ) {}

  // create a factory that will return the correct client instance based on the cardData.clientId and params
  getClient(params: Params, cardData: ICommonPaymentData): IBaseClient {
    switch (cardData.clientId?.toLowerCase()) {
      case 'tmx':
        return this.timxClient;
      case 'war':
        return this.zohoClient;
      case 'sbh':
        return this.sbhClient;
      case 'cbl':
        if (params['timxRefId']) {
          return this.timxClient;
        }
        return this.cblClient;
      default:
        return this.unknownClient;
    }
  }
}
